module.exports = __webpack_public_path__ + "img/7a.64253bd4.jpg";